<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="KOMITENTEMAIL.NAZIV.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtEmail"
                formControlName="Naziv"
                #focusElement
                [MaxLength]="50"
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                [Label]="'KOMITENTEMAIL.NAZIV.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                    <span *ngFor="let validation of errorMessages.Naziv">
                      <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                    <span class="error-message" *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkEmail && !this.baseFormGroup.errors.checkEmail.valid"><span translate="{{this.baseFormGroup.errors.checkEmail.message}}"></span></span>
              </div>
            </div>
          </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <div class="col-md-12">
                <div class="form-check" style="padding-top: 22px">
                <!-- <input
                  style="width: 20px;"
                  type="checkbox"
                  name="chkGlavni"
                  formControlName="Glavni"
                  > -->
                  <input
                  class="form-check-input" 
                  type="checkbox"
                  formControlName="Glavni"
                  id="chkGlavni"
                  >
                  <label class="form-check-label" for="chkGlavni"><span translate="KOMITENTEMAIL.GLAVNI.SINGULAR"></span></label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
              <div class="form-group row">
                
                <div class="col-md-12">
                  <div class="form-check" style="padding-top: 22px">
                  <!-- <input
                    style="width: 20px;"
                    type="checkbox"
                    name="chkSef"
                    formControlName="ZaSef"
                    > -->
                    <input
                    class="form-check-input" 
                    type="checkbox"
                    formControlName="ZaSef"
                    id="chkSef"
                    >
                    <label class="form-check-label" for="chkSef"><span translate="KOMITENTEMAIL.ZASEF.SINGULAR"></span></label>
                  </div>
              </div>
            </div>
          </div>
        </div> 
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="KOMITENTEMAIL.SVOJINA.SINGULAR"></span></label> -->
          <div class="col-md-12">
              <!-- <yt-fw-dropdown
              [ModelName]="'svojina'"
              [GetName]="'get'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [AllowAddNew]='true'
              [Required]='true'
              [Disabled]='false'
              formControlName="SvojinaID"
              name="cmbSvojina"
              [Type]="ID"
              [ngClass]="{'is-invalid': submitted && fc.SvojinaID.invalid}"
              [Label]="'KOMITENTEMAIL.SVOJINA.SINGULAR'">
            </yt-fw-dropdown> -->
            <yt-dropdown-picklist
                    [ModelName]="'svojina'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="false"
                    formControlName="SvojinaID"
                    [Label]="'KOMITENTEMAIL.SVOJINA.SINGULAR'"
                    >
                    </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.SvojinaID.invalid">
                <span *ngFor="let validation of errorMessages.SvojinaID">
                  <span class="error-message" *ngIf="fc.SvojinaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="KOMITENTEMAIL.OPIS.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtOpis"
              formControlName="Opis"
              [MaxLength]="100"
              [Label]="'KOMITENTEMAIL.OPIS.SINGULAR'"
              >
            </yt-input>
          </div>
        </div> 
      </div>
    </div>
  </div>
</form>
